/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type R7UrceniEditoraZpsDestroyRequest = {} | null | undefined;
export type R7UrceniEditoraZpsDestroyResponse = any;

export type R7UrceniEditoraZpsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this urceny editor zps.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_destroy
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const r7UrceniEditoraZpsDestroyOperation = ({
  id,
  ...rest
}: R7UrceniEditoraZpsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/r7_urceni_editora_zps/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/r7_urceni_editora_zps/{id}/' };
  };

/**
 * DELETE /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_destroy
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const r7UrceniEditoraZpsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: R7UrceniEditoraZpsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = r7UrceniEditoraZpsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
